import React from 'react';
import { useSelector } from 'react-redux';
import { getCoverImages } from '@src/containers/ProfileVenue/selectors/getCoverImages';
import { getIsPrivate } from '@src/containers/ProfileVenue/selectors/getIsPrivate';
import { useLoadMediaWatcher } from '@src/containers/ProfileVenue/hooks';
import { activeSpecId } from '@src/containers/ProfileVenue/selectors';
import HeaderGalleryComponent from './commonProfile';

const HeaderGalleryConnector = () => {
	const images = useSelector(getCoverImages);
	const isPrivate = useSelector(getIsPrivate);
	const activeSpec = useSelector(activeSpecId);
	const { loadMediaWatcher } = useLoadMediaWatcher();

	return (
		<HeaderGalleryComponent
			images={images}
			isPrivate={isPrivate}
			activeSpec={activeSpec}
			refetchData={loadMediaWatcher}
		/>
	);
};

export default HeaderGalleryConnector;
